const LINKS = {
  'Help Center': 'https://support.brandlive.com',
  'Product Tour': 'https://onthelot.brandlive.com/Product-Tour/en',
  'Director’s Cut': 'https://www.brandlive.com/blog',
};

export function Resources(): JSX.Element {
  return (
    <div className="auth-resources">
      <p>Resources</p>
      <div>
        {Object.entries(LINKS).map(([name, url]) => {
          return (
            <a key={name} className="auth-resource-link" href={url} target="_blank" rel="noopener noreferrer">
              {name}
            </a>
          );
        })}
      </div>
    </div>
  );
}
